import { connect } from "react-redux";
import React from "react";
import { TableCell, TableRow } from "@mui/material";
import {
  ListAlt,
  MenuOpen,
} from "@mui/icons-material";
import BasicMenu from "helpers/menu";
import FormDialog from "helpers/FormDialog";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import DatatableComponent from "helpers/DatatableComponent";

const ExpandedRows = (props) => {
  const {  setOpen, setId, setValue0, parent} = props;
  const list = parent?.subMenus ?? [];
  const [openAction, setOpenAction] = React.useState(false);
  const [code, setCode] = React.useState(0);

  return (
    <>
      {list?.map((row, key) => {
        return (
          <>
            <TableRow
              key={row.id}
            >
              <TableCell align="right" component="th" scope="row" >
                <MenuOpen />
              </TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.Menu?.type}</TableCell>
              <TableCell>{row.icon}</TableCell>
              <TableCell>
                <BasicMenu
                  onEdit={() => {
                    setOpen(2);
                    setId(row?.id);
                    setValue0("name", row?.name);
                    setValue0("icon", row?.icon);
                    setValue0("order", row?.order);

                  }}
                  onDetails={() => {
                    setCode(row.code);
                    setOpenAction(true);
                  }}
                  detailsName="Actions"
                />
              </TableCell>
            </TableRow>
            {row?.actions?.map((action) => (
              <TableRow
                key={action.code}
                sx={{
                  display:
                    code === row.code && openAction ? "table-row" : "none",
                }}
              >
                <TableCell>
                  <ListAlt />
                </TableCell>
                <TableCell>{action.code}</TableCell>
                <TableCell>{action.name}</TableCell>
                <TableCell>{action.Menu?.type}</TableCell>
                <TableCell >
                  {action.type}
                </TableCell>
                <TableCell >
                  <BasicMenu
                    onEdit={() => {
                      setOpen(2);
                      setId(action?.id);
                      setValue0("name", action?.name);
                      setValue0("icon", action?.icon);
                      setValue0("order", action?.order);
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </>
        );
      })}
    </>
  );
};

const StructureMenu = ({ category, location }) => {


  const [open, setOpen] = React.useState(0);
  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [type, setType] = React.useState(category);


  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "Menu",
      label: "Type",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          return v?.type
        },
      },
    },
    {
      name: "icon",
      label: "Icon",
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => {
          const obj = list.find((vx) => vx.id === v);

          return<div className="flex items-center">
            <BasicMenu
              onEdit={() => {
                setOpen(2);
                // const obj = list.find((vx) => vx.id === v);
                setId(v);
                setValue0("name", obj?.name);
                setValue0("icon", obj?.icon);
                setValue0("order", obj?.order);

              }}
            />
          </div>
        },
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  return (
    <div className="w-full mb-12 px-4">

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={() => {
          window.location.reload();
        }}
        setOpen={setOpen}
        url={`/api/structure/structure/menu/update/${id}`}
        title={ "Edit"}
        fields={[
      
          {
            name: "name",
            label: "Name",
            value: value["name"] || "",
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
      
          {
            name: "icon",
            label: "Icon",
            value: value["icon"] || "",
            col: 12,
            setValue: (val) => setValue0("icon", val),
          },
          {
            name: "order",
            label: "Order",
            value: value["order"] || "",
            hidden:value["type"]!=="menu",
            col: 12,
            setValue: (val) => setValue0("order", val),
          },
   
        ]}
      />
      <DatatableComponent
        order={location.state?.order}
        search={false}
        viewColumns={false}
        searchfield={true}
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        elevation={1}
        columns={columns}
        url={`/api/structure/structure/menu/dataTable?type=${category}`}
        title={``}
        expandableRows={type === "menu"}
        renderExpandableRow={(rowData, rowMeta) => {
          let index2 = rowMeta?.dataIndex;
          return (
            <ExpandedRows
              index={index2}
              setOpen={setOpen}
              setId={setId}
              setValue0={setValue0}
              parent={list[index2]}
              setType={setType}
            />
          );
        }}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureMenu);
